$(document).ready(function () {
  function shouldShowPopup() {
    const lastShownDate = Cookies.get("popupShown");
    const today = new Date().toDateString();
    return !lastShownDate || lastShownDate !== today;
  }

  function setPopupShownCookie() {
    const today = new Date().toDateString();
    Cookies.set("popupShown", today, { expires: 1 }); // Expires in 1 day
  }

  var customPopup = $("#customEmailPop");
  var emailInput = $(".cp-email");
  var copyBtnIcon = $(".custompopup-copy-btn-icon");
  var copiedIcon = $(".copied-text-icon");
  var customPopupgen = $("#customDiscountPop");
  copiedIcon.hide();

  $(".custom-sidebar-dc").on("click", function () {
    // Check if the modal is already displayed
    if ($("#customEmailPop").css("display") !== "flex") {
      $(".custom-sidebar-dc").hide();
      $("#customEmailPop").css("display", "flex");
    }
  });

  if (shouldShowPopup()) {
    setTimeout(function () {
      customPopup.show();
      setPopupShownCookie();
    }, 3000);
  }

  $("#customEmailPop .custompopup-shop-now-btn").on("click", function () {
    var email = emailInput.val().trim();
    if (isValidEmail(email)) {
      customPopup.hide();
      emailInput.val("");
      $(".cp-error").hide();
      $("#customDiscountPop").show();
    } else {
      $(".cp-error").show();
    }
  });

  function closePopup() {
    customPopup.hide();
    $(".cp-error").hide();
    $(".custom-sidebar-dc").show();
  }

  function closePopupGen() {
    customPopupgen.hide();
    $(".custom-sidebar-dc").show();
  }

  function isValidEmail(email) {
    // Regular expression for validating an Email
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function copyDiscountCode() {
    var inputElement = $(".custompopup-input");

    navigator.clipboard
      .writeText(inputElement.val())
      .then(function () {
        copyBtnIcon.hide();
        copiedIcon.show();
        setTimeout(function () {
          copiedIcon.hide();
          copyBtnIcon.show();
        }, 1000);
      })
      .catch(function (err) {
        console.error("Copy failed:", err);
      });
  }

  $("#customEmailPop .custompopup-close-btn").on("click", closePopup);
  $("#customDiscountPop .custompopup-close-btn").on("click", closePopupGen);
  $("#customDiscountPop .custompopup-shop-now-btn").on("click", closePopupGen);
  $(".no-thanks").on("click", closePopup);
  $(".custompopup-copy-btn").on("click", copyDiscountCode);
});

document.addEventListener("DOMContentLoaded", function () {
  // Find all elements with class "footer-block grid__item"
  var footerBlocks = document.querySelectorAll(".footer-block.grid__item");

  // Check if there are footer blocks
  if (footerBlocks.length > 0) {
    // Get the first footer block
    var firstFooterBlock = footerBlocks[0];

    // Find the first <h2> element within the first footer block
    var h2Element = firstFooterBlock.querySelector("h2");

    // Check if the <h2> element exists
    if (h2Element) {
      // Create a new element with the desired content
      var newContent = document.createElement("div");
      newContent.className = "header__heading-logo-wrapper";

      var imgElement = document.createElement("img");
      imgElement.src =
        "//tsuritrends.com/cdn/shop/files/Transparent_Text_Logo_300px.png?v=1696851059&amp;width=600";
      imgElement.alt = "Tsuri Trends";
      imgElement.srcset =
        "//tsuritrends.com/cdn/shop/files/Transparent_Text_Logo_300px.png?v=1696851059&amp;width=130 130w, //tsuritrends.com/cdn/shop/files/Transparent_Text_Logo_300px.png?v=1696851059&amp;width=195 195w, //tsuritrends.com/cdn/shop/files/Transparent_Text_Logo_300px.png?v=1696851059&amp;width=260 260w";
      imgElement.width = "130";
      imgElement.height = "65.0";
      imgElement.loading = "eager";
      imgElement.className = "header__heading-logo motion-reduce";
      imgElement.sizes = "(max-width: 260px) 50vw, 130px";

      newContent.appendChild(imgElement);

      // Replace the content of the <h2> element with the new content
      h2Element.innerHTML = "";
      h2Element.appendChild(newContent);
    }
  }
});

$(document).ready(function () {
  $(".custom-slides").slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "ease-in-out",
    autoplay: true,
    autoplaySpeed: 5000,
  });
});

$(document).ready(function () {
  $(".multiple-items").slick({
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});



$().ready(function () {
  $(".collection-listkrk").slick({
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});





$().ready(function () {
  $(".collection-listkr").slick({
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow:2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});


$().ready(function () {
  $(".collection-listrr-mobile").slick({
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});





// Get the h1 element
var h1Element = document.querySelector("h1");
if (h1Element) {
  // Check if the URL contains "refund-policy"
  if (window.location.href.indexOf("refund-policy") > -1) {
    // If it does, update the content of the h1 element to "Return Policy"
    h1Element.innerText = "Return Policy";
  }
}

var dp = document.querySelector(".discount-percentage");
// Check if the element is found
if (dp) {
  // Check if the URL contains "collections" or if it is the home page
  if (
    window.location.href.indexOf("collections") > -1 ||
    window.location.pathname === "/"
  ) {
    // If it does, update the style of the element
    dp.style.display = "none";
  }
}

// Check if the current URL contains "terms-of-service"
if (window.location.href.indexOf("terms-of-service") > -1) {
  // Create a style element
  var style = document.createElement("style");
  style.type = "text/css";
  // Define the CSS rule
  var css = "ol li span {font-weight: 600 !important}";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  // Append the style element to the document head
  document.head.appendChild(style);
}

// Check if the current URL matches the old URL

document.addEventListener("DOMContentLoaded", function () {
  // Select the div with the class "multiple-items"
  var multipleItemsDiv = document.querySelector(".multiple-items");

  // Check if the div is found
  if (multipleItemsDiv) {
    // Select all images inside the "multiple-items" div
    var imagesInsideMultipleItems = multipleItemsDiv.querySelectorAll("img");

    // Add the "lazy-load" class to each image
    imagesInsideMultipleItems.forEach(function (img) {
      img.classList.add("lazy-load");
    });

    // Set up Intersection Observer for lazy loading
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy-load");
          imageObserver.unobserve(lazyImage);
        }
      });
    });

    // Observe images with the "lazy-load" class
    imagesInsideMultipleItems.forEach(function (lazyImage) {
      // Save the current src to data-src
      lazyImage.dataset.src = lazyImage.src;
      // Clear the src to initiate lazy loading
      lazyImage.removeAttribute("src");
      if (lazyImage.classList.contains("lazy-load")) {
        imageObserver.observe(lazyImage);
      }
    });
  }
});
